import React, { useMemo, useState } from "react";
import { Tooltip } from "@mui/material";
import { useTable, useSortBy, usePagination } from "react-table";

import Loader from "../Other/Loader";
import { COLUMNS } from "./ordersData";
import ModalOrders from "./ModalOrders";
import { TableApi } from "../interfaces";
import BillingPagination from "../Other/BillingPagination";
import { ReactComponent as Up } from "../../../../assets/svg/sort_up.svg";
import { ReactComponent as Down } from "../../../../assets/svg/sort_down.svg";

const OrdersTable = ({ data, pageCount, fetchData, loading }: TableApi) => {
  const [rowValue, setRowValue] = useState(null);
  const [active, setActive] = useState(false);
  const columns = COLUMNS;
  const orders = data;

  const takeOrderDescription = (value) => {
    setRowValue(value);
    setActive(true);
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    pageOptions,
    state: tableDetails,
    prepareRow,
    gotoPage,
  } = useTable(
    {
      columns,
      data: orders,
      manualPagination: true,
      autoResetPage: false,
      pageCount,
      initialState: {
        pageIndex: 0,
      },
    },
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize } = tableDetails;

  React.useEffect(() => {
    fetchData &&
      fetchData({
        pageIndex,
        pageSize,
        url: "/api/order/get-orders",
      });
  }, [fetchData, pageIndex, pageSize]);

  return (
    <>
      {active && <ModalOrders rowValue={rowValue} setActive={setActive} />}

      {loading ? (
        <Loader />
      ) : (
        <>
          <table
            style={{ minWidth: "250px" }}
            className="billing-tables"
            {...getTableProps()}
          >
            <thead>
              {headerGroups?.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers?.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}
                      <span className="sort-icon">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <Down />
                          ) : (
                            <Up />
                          )
                        ) : (
                          ""
                        )}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page?.map((row) => {
                prepareRow(row);
                return (
                  <Tooltip key={row.id} title="Click to Open" placement="top">
                    <tr
                      style={{ cursor: "pointer" }}
                      onClick={() => takeOrderDescription(row.original)}
                      {...row.getRowProps()}
                    >
                      {row.cells?.map((cell) => {
                        return (
                          <td key={cell.id} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  </Tooltip>
                );
              })}
            </tbody>
          </table>
          <BillingPagination
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            gotoPage={gotoPage}
          />
        </>
      )}
    </>
  );
};

export default OrdersTable;
